import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import VendorAccountsPage from "@/features/accounts/components/VendorAccountsPage";
import styles from "./installer-vendors.module.scss";

/**
 * Existing Super Admin Installer Vendors page — wired to canonical
 * Master Account list/create (kind=installer-vendor) + Support Mode.
 * Roles / Pending Approvals pages remain separate nav entries.
 */
const InstallerVendors: React.FC = () => (
  <VendorAccountsPage
    kind="installer-vendor"
    title="Installer Vendors"
    idColumnLabel="Installer Vendor ID"
    addButtonLabel="Add Installer"
    addModalTitle="Add New Installer Vendor"
    styles={styles}
  />
);

export default withAuthenticationRequired(InstallerVendors);
